<template>
  <section>
    <div class="left">
      <h2 v-translate>Akce po kliku na tlačítko</h2>
    </div>

    <div class="right">

      <div class="field_left">
        <select-box
            id="action_type"
            v-model="entity.action_type"
            :options="actionTypeOptions"
            :disabled="!isEditable"
            :omit-label="true"
            @input="onActionChange"
        >
        </select-box>
      </div>
      <div class="field_right" v-if="showSearchBroadcast">
        <a class="btn" v-if="isEditable" @click.stop="$emit('broadcast-search-modal', entity.action_id)" v-translate>
          Vybrat vysílání
        </a>
        <ul class="selected_results">
          <li v-for="id in entity.action_id" :key="id" :class="{'disabled': !isEditable}">
            <span><a class="close" @click="removeBroadcast(id)" v-translate>Odstranit</a></span>
            <span class="item_id">{{id}} </span>
            <span>{{getBroadcastName(id)}}</span>
          </li>
        </ul>
      </div>
      <div v-if="showSearchChannel">
      <multiselect-searchbox
          :searchFunction="searchChannels"
          v-model="entity.action_id"
          :show-id="true"
          :disabled="!isEditable"
          :only-one="true"
          name="selectchannelmultiselect"
          id="selectchannelid"
      >{{ $gettext('Kanál') }}</multiselect-searchbox>
      </div>
      <div v-if="showSearchChannelPackage" class="field_left">
        <text-input id="selectitemid"
                    v-model="entity.action_id"
                    :disabled="!isEditable"
                    ref="selectitemidref"
        >
          <translate class="translate">Id předvybrané položky</translate>
        </text-input>
      </div>
    </div>
  </section>
</template>

<script>
import AdvertisingBanners from "./../mixins/advertisingBanners";

export default {
  name: "AdvertisingBannerActions",
  mixins: [AdvertisingBanners],
  props: {
    entity: Object,
    isEditable: Boolean,
    broadcastNames: Object,
  },
  created(DashboardCarouselService, ChannelService, PackageService) {
    this.dashboardCarouselService = DashboardCarouselService;
    this.channelService = ChannelService;
    this.packageService = PackageService;
  },
  computed: {
    showSearchBroadcast(){
      switch(this.entity.action_type){
        case 'to_broadcast_detail':
        case 'play_catchup_broadcast':
        case 'create_pvr':
          return true;
        default:
          return false;
      }
    },
    showSearchChannel(){
      return this.entity.action_type === 'play_channel_live';
    },
    showSearchChannelPackage(){
      return this.entity.action_type === 'to_selfservice';
    },
  },
  methods: {
    searchChannels(search, selectAll = false) {
      return this.channelService.searchChannelsByName({search: search, active_in_platform: true, id_selected_operator: this.$_loggedUser_selectedOperatorId, select_all: selectAll});
    },
    onActionChange(){
      if(this.entity.action_type === 'to_selfservice'){
        this.entity.action_id = '';
      }else{
        this.entity.action_id = [];
      }
    },
    getBroadcastName(id) {
      return this.broadcastNames && this.broadcastNames[id] || ''
    },
    removeBroadcast(itemId) {
      if (!this.isEditable) {
        return;
      }
      this.entity.action_id = this.entity.action_id.filter(id => id !== itemId);
      this.$emit('broadcast-search-input', this.entity.action_id);
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/components/views/advertisingBanner/Forms/Actions.vue